import { render, staticRenderFns } from "./ProtocolInformation.vue?vue&type=template&id=3c1d84ab"
import script from "./ProtocolInformation.vue?vue&type=script&lang=js"
export * from "./ProtocolInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports